export default __webpack_public_path__ + "static/media/franchise-asia-ph.68952a61.jpg";